import React, { Component } from 'react';
import Black from "../resources/black_page.jpg"
import "./music.css"
import SpotifyPlayer from 'react-spotify-player';
 
// size may also be a plain string using the presets 'large' or 'compact'
const size = {
  width: '100%',
  height: 300,
};
const view = 'list'; // or 'coverart'
const theme = 'black'; // or 'white'
 
class Music extends Component {
    render() {
        return (
            <div className="music">
                <SpotifyPlayer
                uri="spotify:album:2L9dEKZoiwdB9sYEy6vZu4"
                size={size}
                view={view}
                theme={theme}
                />
            </div>
        );
    }
}

export default  Music;




